import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Banner } from '../../components';
import { Loader } from '../../components';
import { useParams } from "react-router-dom";
import { NewsArticle } from '../../components';
import {FeaturedCarousel} from '../../components'
import { BaseUrl } from "../../config";

const NewsSingleContainer = (props) => {
  const loader = useSelector((state) => state.loader);
  const [isFetching, setIsFetching] = useState(true)
  const [slugParams, setSlugParams] = useState('')
  const [newsData, setNewsData] = useState({})
  const [newsCategory, setNewsCategory] = useState('')
  const [categoryData, setCategoryData] = useState([])
  let arrayToLoad = [
    require('../../assets/parallax-1.jpg')
  ]

  useEffect(() => {
    
    setSlugParams(props.match.params.slug)

    setIsFetching(false)

  },[props.match])

  useEffect(() => {
    
    if(slugParams !== ''){
      fetch(`${BaseUrl}/post?key=invrsion&slug=${slugParams}`, {
        method: 'GET'
      })
      .then(response => {
        return response.json()
        
      }).then((json) =>  {
        setNewsData(json.data.single_news);
        setNewsCategory(json.data.single_news.category)
        
      })
    }
    
  }, [slugParams]);

  useEffect(() => {
    if(newsCategory  != ''){

      fetch(`${BaseUrl}/page?key=invrsion&slug=${newsCategory}&page=${newsCategory}`, {
        method: 'GET',
        headers : { 
          'Accept': 'application/json'
         }
      })
      .then(response => {
        
        return response.json()
        
      }).then((json) =>  {
        let filtered = json.data.index_news.list_news.filter( news => {
          return news.slug !== slugParams
        })
        setCategoryData(filtered);
      })

    }
  }, [newsCategory])

  return (
    <React.Fragment>
      <NewsArticle data={newsData}/>
      {
        categoryData.length > 0 &&
        <FeaturedCarousel featuredData={categoryData} isArticle={true} />

      }
      {/* <Banner text="Want to dive deeper? Get your hands on our press kit" route="/contact" copyRoute="Discover" isDownload={true}/> */}
      <Loader arrayLoad={arrayToLoad} isFetching={isFetching}/>
    </React.Fragment>
  );
};

export default NewsSingleContainer;
